import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MCBQS040CreateRequest } from 'types/MCBQS040/MCBQS040CreateRequest'
import { MCBQS040InitRequest } from 'types/MCBQS040/MCBQS040InitRequest'
import {
     MCBQS040JobSeekerSubmissionInfoDto,
     MCBQS040SeminarInfoOutDto,
     MCBQS040JobSeekerByCompanyIdInfoDto,
     MCBQS040CreateInfoOutDto,
     MCBQS040SelectionFileMergeInfoDto } from 'pages/MCBQS040/formConfig'
import { MCBQS050InitRequest } from 'types/MCBQS050/MCBQS050InitRequest'

// ファイルを作成する条件 start
const mCBQS040CreateRequestValue: MCBQS040CreateRequest = {
    // 選択されたMCB提出内容情報
    selectedMcbSubmissionRequestInfo: [],
    // 応募者詳細PDF
    jobSeekerPdfFlag: '0',
    // イメジス出力フラグ
    imagesPdfFlag: '0',
    // GAB出力フラグ
    gabPdfFlag: '0',
    // OPQ出力フラグ
    opqPdfFlag: '0',
    // CAB出力フラグ
    cabPdfFlag: '0',
    // イメジス出力企業別求職者IDリスト
    imagesJobSeekerByCompanyIdList: [],
    // GAB出力企業別求職者IDリスト
    gabJobSeekerByCompanyIdList: [],
    // OPQ出力企業別求職者IDリスト
    opqJobSeekerByCompanyIdList: [],
    // CAB出力企業別求職者IDリスト
    cabJobSeekerByCompanyIdList: [],
    // 選択された選考ファイル情報
    selectedSelectionFileList: [],
    // 出力形式
    outputFormatFlag: '0',
    // ソート順
    sortOrder: '1',
    // 選択されたセミナー詳細情報リスト
    selectedSeminarDetailList: [],
    // CSV出力有無
    csvOutputFlag: '0',
    // 出力タイトル
    outputTitle: '',
    // 選考ファイル選択件数上限値
    maxSelectionFileSelectCount: 5,
    // 年度判別媒体フラグ
    yearDeterminingMediaFlag: '',
    // 企業別求職者IDリスト
    jobSeekerByCompanyIdInfo: [],
    // 応募者ソート順
    applicantSortKind: 0,
    // 確認モーダフラグ '1':確認済み '0'；初め
    confirmationFlag: '0',
    //「出力する」ボタン押下処理の戻り値
    createInfoOutDto: {// 画面表示用応募者の出力対象ファイルリスト
        applactionLst: [],
        // 出力対象件数
        targetCount: 0,
        // 提出物内容名
        submissionContentName: ''
    }
}

// ファイルを作成する条件 end

//  初期検索条件 start
// 初期検索結果
export interface DisplayInfoDto {
    // 提出物内容マージ情報
    submissionContentMergeInfo: MCBQS040SubmissionContentMergeInfoDto[];
    // SHLテスト結果情報
    shlTestReslutInfo: MCBQS040SHLTestReslutInfoDto;
    // 選考ファイルマージ情報
    selectionFileMergeInfo: MCBQS040SelectionFileMergeInfoDto[];
    // セミナーマージ情報
    seminarMergeInfo: MCBQS040SeminarMergeInfoDto[];
    // 選考ファイル選択件数上限値
    maxSelectionFileSelectCount: number;
    // 年度判別媒体フラグ
    yearDeterminingMediaFlag: string;
    // 企業ID
    companyId: number;
    // 企業別求職者IDリスト
    jobSeekerByCompanyIdInfo: MCBQS040JobSeekerByCompanyIdInfoDto[];
    // 提出物ファイル情報
    mcbFileInfo: MCBQS040McbFileInfoOutDto[];
}


// セミナーマージ情報
export interface MCBQS040SeminarMergeInfoDto {
    // セミナーID
    seminarId: string;
    // 連携元セミナー識別キー
    coordinationFormerSeminarIdentificationKey: string;
    // セミナー名
    seminarName: string;
    // セミナー詳細情報リスト
    seminarDetailList: MCBQS040SeminarInfoOutDto[];
}



// SHLテスト結果情報
export interface MCBQS040SHLTestReslutInfoDto {
    // イメジス出力フラグ
    imagesPdfFlag: string;
    // GAB出力フラグ
    gabPdfFlag: string;
    // OPQ出力フラグ
    opqPdfFlag: string;
    // CAB出力フラグ
    cabPdfFlag: string;
    // イメジス出力企業別求職者IDリスト
    imagesJobSeekerByCompanyIdList: number[];
    // GAB出力企業別求職者IDリスト List<Long>
    gabJobSeekerByCompanyIdList: number[];
    // OPQ出力企業別求職者IDリスト List<Long>
    opqJobSeekerByCompanyIdList: number[];
    // CAB出力企業別求職者IDリスト List<Long>
    cabJobSeekerByCompanyIdList: number[];
}

//提出物内容マージ情報
export interface MCBQS040SubmissionContentMergeInfoDto {
    // 提出物内容ID
    submissionContentId: number;
    // 提出物内容名
    submissionContentName: string;
    // 提出物エントリシートフラグ
    submissionEntrySheetFlag: string;
    // 提出物履歴書フラグ
    submissionResumeFlag: string;
    // 提出物研究概要書フラグ S
    submissionResearchSummaryFlag: string;
    // 提出物オリジナル設問フラグ
    submissionOriginalQuestionFlag: string;
    // 提出物ファイルリスト
    mcbFileInfoList: MCBQS040McbFileInfoOutDto[];
    // 提出件数 Integer
    submissionCount: number;
    // 応募者提出物情報リスト
    jobSeekerSubmissionInfoList: MCBQS040JobSeekerSubmissionInfoDto[]
}

// 提出物ファイル
export interface MCBQS040McbFileInfoOutDto {
    // 提出リクエストID
    submissionRequestId: number;
    // ファイル提出格納パス
    fileSubmissionFullpath: string;
    // ファイル提出物ファイル設問タイトル
    fileSubmissionFileQuestionTitle: string;
    // ファイル提出物表示順
    fileSubmissionDisplayOrder: number;
    // 企業別求職者ID
    jobSeekerByCompanyId: number;
    // 企業別求職者IDリスト
    jobSeekerByCompanyList: number[];
}



const displayInfoDtoValue: DisplayInfoDto = {
    // 提出物内容マージ情報
    submissionContentMergeInfo: [],
    // SHLテスト結果情報
    shlTestReslutInfo: {
        // イメジス出力フラグ
        imagesPdfFlag: '',
        // GAB出力フラグ
        gabPdfFlag: '',
        // OPQ出力フラグ
        opqPdfFlag: '',
        // CAB出力フラグ
        cabPdfFlag: '',
        // イメジス出力企業別求職者IDリスト
        imagesJobSeekerByCompanyIdList: [],
        // GAB出力企業別求職者IDリスト List<Long>
        gabJobSeekerByCompanyIdList: [],
        // OPQ出力企業別求職者IDリスト List<Long>
        opqJobSeekerByCompanyIdList: [],
        // CAB出力企業別求職者IDリスト List<Long>
        cabJobSeekerByCompanyIdList: [],
    },
    // 選考ファイルマージ情報
    selectionFileMergeInfo: [],
    // セミナーマージ情報
    seminarMergeInfo: [],
    // 選考ファイル選択件数上限値
    maxSelectionFileSelectCount: 5,
    // 年度判別媒体フラグ
    yearDeterminingMediaFlag: '',
    // 企業ID
    companyId: 0,
    // 企業別求職者IDリスト
    jobSeekerByCompanyIdInfo: [],
    // 提出物ファイル情報
    mcbFileInfo: [],
}

const mCBQS040CreateInfoOutDtoValue:MCBQS040CreateInfoOutDto = {
    // 画面表示用応募者の出力対象ファイルリスト
    applactionLst:[],
    // 出力対象件数
    targetCount:0,
    // 提出物内容名
    submissionContentName:''
}

// 初期検索条件 end

interface mcbPdfDownload {
    // 画面初期検索結果
    displayInfo: DisplayInfoDto,
    // オープンフラグ
    mCBQS040OpenFlg: boolean,
    openDialog2:boolean,
    // ファイルを作成する条件
    PdfDownloadCreateCondition: MCBQS040CreateRequest,
    creatEventResponsDto:MCBQS040CreateInfoOutDto,
   // MCBQS050オープンフラグ
 	MCBQS050OpenFlag: boolean,
   //「MCBQS050_PDFダウンロード（セット出力）（一括）」画面用
   MCBQS050InitCondition: MCBQS050InitRequest
}

// 対象件数
const mCBQS050InitRequestValue : MCBQS050InitRequest = {
    outputCount : '',
}

const initialState: mcbPdfDownload = {
    // 画面初期検索結果
    displayInfo: displayInfoDtoValue,
    // ファイルを作成する条件
    PdfDownloadCreateCondition: mCBQS040CreateRequestValue,
    mCBQS040OpenFlg: false,
    openDialog2:false,
    creatEventResponsDto:mCBQS040CreateInfoOutDtoValue,
    MCBQS050InitCondition: mCBQS050InitRequestValue,
 	MCBQS050OpenFlag: false,
}

const setOutputSlice = createSlice({
    name: 'setOutput',
    initialState,
    reducers: {

        // 画面表示フラグ
        setMCBQS040OpenFlg(state, action: PayloadAction<boolean>) {
            state.mCBQS040OpenFlg = action.payload
            return state
        },
        // 画面初期表示時、DBを検索
        selectInitInfo(
            state,
            action: PayloadAction<MCBQS040InitRequest>
        ) {
            return state
        },
        // 画面初期検索結果格納
        setInitResult(state, action: PayloadAction<DisplayInfoDto>) {
            state.displayInfo = action.payload
            return state
        },
        creatListInfo(state, action: PayloadAction<{formData:MCBQS040CreateRequest,setOpenDialog2: (value: boolean) => void}>) {
           state.PdfDownloadCreateCondition = action.payload.formData
            return state
        },
        //「出力する」ボタン押下処理戻り値
        creatEventResponsDto(state, action: PayloadAction<MCBQS040CreateInfoOutDto>) {
           // console.log('creatEventResponsDto-----', JSON.stringify(action.payload));
           state.creatEventResponsDto = action.payload;
           state.openDialog2 =true;
            
            return state
        },
        //対象件数設定
        //「MCBQS050_PDFダウンロード（セット出力）（一括）」画面用
        setMCBQS050InitInfo(state,action:PayloadAction<string>){
            state.MCBQS050InitCondition.outputCount = action.payload.toString()
            return state
        },
        setMCBQS050OpenFlag(state, action: PayloadAction<boolean>) {
          state.MCBQS050OpenFlag = action.payload
          return state
        },
    },
})

export const {
    setInitResult,
    selectInitInfo,
    creatListInfo,
    setMCBQS040OpenFlg,
    creatEventResponsDto,
    setMCBQS050InitInfo,
    setMCBQS050OpenFlag,
} = setOutputSlice.actions

export default setOutputSlice.reducer
